import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  display: "inline-block",
};

export const infoTip: CSSProperties = {
  fontSize: 16,
  height: 16,
  width: 16,
  left: 4,
  top: 1,
  color: greys.slate,
  position: "relative",
};

export const tipText: CSSProperties = {
  display: "block",
  background: "#fff",
  textAlign: "center",
  padding: "5px",
  margin: "5px 0",
  borderRadius: "3px",
  border: "1px solid #fff",
  position: "absolute",
  zIndex: 10,
  minWidth: "250px",
  boxShadow: "rgba(38, 50, 56, 0.5) 1px 1px 5px",
};

export const arrow: CSSProperties = {
  width: 0,
  height: 0,
  borderLeft: "5px solid transparent",
  borderRight: "5px solid transparent",
  borderBottom: "5px solid #fff",
  position: "absolute",
  top: "-5px",
  left: "5px",
};
